export const NEW = "NEW";
export const COMING_SOON = "COMING_SOON";

export type SideNavItemStatus = typeof NEW | typeof COMING_SOON;

export type SideNavPill = {
  variant: "info" | "warning" | "danger" | "success";
  text: string;
};
